
export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="contact" className="bg-[#1C1C1E] py-16">
      <div className="max-w-7xl mx-auto px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          <div>
            <img 
              src="https://static.readdy.ai/image/0fc33fa68f46f743570ad8ba1c3172ea/587d4bfe7b2d3053bc3f394890cbc68c.png" 
              alt="carfuagency" 
              className="h-12 w-auto mb-4"
            />
            <p className="font-serif text-[#8A8F98] text-sm italic">
              AI Systems for Legal Excellence
            </p>
          </div>
          
          <div>
            <h4 className="text-[#F7F5F2] font-semibold mb-4 text-sm tracking-wide">Quick Links</h4>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="text-[#8A8F98] hover:text-[#C8A14A] transition-colors text-sm cursor-pointer"
                >
                  Services
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('process')}
                  className="text-[#8A8F98] hover:text-[#C8A14A] transition-colors text-sm cursor-pointer"
                >
                  How It Works
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('cta')}
                  className="text-[#8A8F98] hover:text-[#C8A14A] transition-colors text-sm cursor-pointer"
                >
                  Contact
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h4 className="text-[#F7F5F2] font-semibold mb-4 text-sm tracking-wide">Our Commitment</h4>
            <p className="text-[#8A8F98] text-sm leading-relaxed">
              Confidential. Secure. Professional.
            </p>
          </div>
        </div>
        
        <div className="border-t border-[#8A8F98]/20 pt-8">
          <div className="flex flex-col md:flex-row justify-center items-center">
            <p className="text-[#8A8F98] text-xs">
              © 2025 carfuagency. All rights reserved.
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
